// // src/CategoryCard.jsx
// import React from 'react';

// const CategoryCard = ({ category }) => {
//   const { title, subtitle, bgColor, bgPattern, textColor, textShadow, titleSize } = category;

//   return (
//     <div
//       className={`
//         w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48
//         ${bgColor} ${bgPattern}
//         rounded-xl
//         flex flex-col items-center justify-center
//         p-2
//         overflow-hidden
//         relative
//         shadow-md 
//       `}
//     >
//       <div className="flex flex-col items-center justify-center -space-y-1"> {/* Negative margin for closer lines */}
//         <h2
//           className={`
//             text-center
//             font-fredoka // Apply the custom font
//             font-extrabold
//             leading-none // Remove extra line height
//             ${textColor}
//             ${textShadow}
//             ${titleSize}
//             ${category.id === 3 ? 'uppercase' : ''} // Pattu Saree title is uppercase
//           `}
//         >
//           {title}
//         </h2>
//         {subtitle && (
//           <p
//             className={`
//               text-center
//               font-fredoka // Apply the custom font
//               font-extrabold // Subtitle also appears bold in the image
//               leading-none
//               ${textColor}
//               ${textShadow}
//               ${category.id === 3 ? 'text-sm' : 'text-xl'} // Smaller font for Pattu Saree subtitle
//             `}
//           >
//             {subtitle}
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CategoryCard;

import React from "react";

const SubCategoryCard = ({ category }) => {
  const {
    title,
    subtitle,
    bgColor,
    bgPattern,
    textColor,
    textShadow,
    titleSize,
    uppercase = false,
  } = category;

  return (
    <div
      className={`
        w-48 h-48
        ${bgColor} ${bgPattern}
        rounded-xl
        flex flex-col items-center justify-center
        p-2
        overflow-hidden
        relative
        shadow-md
        flex-shrink-0
      `}
    >
      <div className="flex flex-col items-center justify-center -space-y-1">
        <h2
          className={`
            text-center
            font-fredoka
            font-extrabold
            leading-none
            ${textColor}
            ${textShadow}
            ${titleSize}
            ${uppercase ? "uppercase" : ""}
          `}
        >
          {title}
        </h2>

        {subtitle && (
          <p
            className={`
              text-center
              font-fredoka
              font-extrabold
              leading-none
              ${textColor}
              ${textShadow}
              text-xl
            `}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default SubCategoryCard;
